import React from 'react';
import ContactPage from './ContactPage'; 
import NewsCard from '../components/NewsCard';
import BigNewsCard from '../components/BigNewsCard'; 
import heroImage from '../images/hero-image.svg'; 
import backgroundImage from '../images/Rectangle 17.svg';
import newsArticles from '../data/newsArticles';
import BrandCarousel from '../components/BrandCarousel';

const providers = [
  'Pharmacy of Children’s Hospitals in Vietnam',
  'Pharmacy of Pediatrics Departments of private and public hospitals in Vietnam',
  'Private and public ophthalmology departments and hospitals in Vietnam',
  'Laboratories in private and public hospitals in Vietnam',
  'Private clinics in Vietnam',
];

const HomePage = () => {
  // Get the first article for the BigNewsCard
  const firstArticle = newsArticles[0];

  // Get the next three articles for the NewsCard components
  const nextThreeArticles = newsArticles.slice(1, 4);

  return (
  <>
    {/* Hero Section */}
    <div className="bg-dark container-fluid px-5 mb-5 d-flex flex-row align-items-center justify-content-start w-100" style={{ height: '634px' }}>
      <div className="d-flex flex-column align-items-start justify-content-center w-100" style={{ gap: '24px', height: '514.61px' }}>
        <div className="d-flex flex-column align-items-start justify-content-start w-100" style={{ gap: '8px' }}>
          <h1 className="text-white fw-bold display-3 fs-1" style={{ maxWidth: '605px' }}>
            Your Solution for Reliable Medical Supply!
          </h1>
          <p className="text-white" style={{ maxWidth: '582px', fontSize: '16px', fontFamily: 'Poppins-Regular' }}>
            Elevate your health journey with exclusive discounts and unparalleled convenience. Your path to well-being starts here, where every purchase is a prescription for savings.
          </p>
        </div>
        <div className="bg-white p-2 d-flex flex-row align-items-center justify-content-center">
          <a className="text-dark fw-bold fs-4" style={{ fontFamily: 'Nunito-Bold' }} href="/contact">Partner With Us</a>
        </div>
      </div>
      <div className='d-none d-lg-block align-items-start justify-content-center' style={{ flexShrink: 0, width: '564px', height: '634px', position: 'relative' }}>
        <img
          src={heroImage}
          alt="Medical Supplies"
          className="w-100 h-auto object-fit-cover"
          style={{
            position: 'absolute',
            left: '564px',
            top: '144px',
            transformOrigin: '0 0',
            transform: 'rotate(0deg) scaleX(-1)',
            maxWidth: '564px',
            maxHeight: '490px',
          }}
        />
      </div>
    </div>

    {/* We Provide to Section */}
    <div className="position-relative my-5">
      <div className="d-flex flex-row align-items-center justify-content-between w-100">
        <img
          src={backgroundImage}
          alt=""
          className="flex-shrink-0 w-auto h-auto object-fit-cover"
          style={{ maxWidth: '1438px', maxHeight: '632px' }}
        />
        <div
          className="flex-shrink-0 w-100"
          style={{
            backgroundColor: '#304a2f',
            height: '632px',
          }}>  
        </div>

      <div
        className="bg-light shadow p-4 d-flex flex-column gap-2 position-absolute end-0
        w-auto w-md-50 start-md-0 translate-middle-md-x-0"
        style={{
          maxWidth: '439px',
        }}
        >
        <h2 className="fw-bold fs-2" >
          We Provide To
        </h2>
        {providers.map((provider, index) => (
          <p key={index} className="py-0 my-0 fs-6">
            <span className="fw-bold py-0 my-0">⦁</span> {provider}
          </p>
        ))}
      </div>

      </div>
      
    </div>

    {/* Brands Section */}
    <div className="container-fluid bg-dark px-0 my-5 d-flex gap-5 flex-wrap align-items-center justify-content-evenly justify-content-xs-center justify-content-md-center justify-content-sm-center w-100" style={{ minHeight: '713px' }}>
      <div className="d-flex flex-column mt-5 align-items-start justify-content-center w-100" style={{ maxWidth: '550px' }}>
        <div className="d-flex flex-column align-items-start justify-content-center h-100">
          <div className="d-flex flex-column px-5 gap-2 align-items-start justify-content-start">
            <h2 className="text-white fw-bold display-3 fs-1">
              BRANDS WE WORK WITH
            </h2>
            <p className="text-white fs-5" style={{ maxWidth: '582px' }}>
              Collaborating with medical professionals and organizations worldwide to enhance patient care through quality supplies.
            </p>
          </div>
        </div>
      </div>
      <BrandCarousel className='mt-5'/>
    </div>

    {/* Call to Action Section */}
<ContactPage/>

    {/* Latest News Section */}
  
    <div className="bg-body-tertiary py-5">
      <div className="container d-flex flex-column gap-4 align-items-center jsutify-content-between">
        <h2 className="fw-bold text-center" style={{ fontSize: '40px' }}>
          Our Latest News &amp; Blogs
        </h2>
        <div className="d-flex gap-4 ">
          {firstArticle && (
            <BigNewsCard
              imageUrl={firstArticle.imageUrl || "rectangle-120.png"}
              category={firstArticle.category || "Doctor"} 
              date={firstArticle.date || "24 Dec, 2023"} 
              title={firstArticle.title || "In this section, we delve into various aspects of health"} 
              description={firstArticle.description || "Explore the world of medical specialties through our blog's spotlight feature. From cardiology to pediatrics, we share in-depth articles written by our expert physicians."} 
              detailsLink={firstArticle.detailsLink}
            />
          )}
          <div className="d-flex flex-column gap-3">
            {nextThreeArticles.map((article, index) => (
              <NewsCard
                key={index}
                imageUrl={article.imageUrl || "rectangle-130.png"} 
                category={article.category || "Doctor"} 
                date={article.date || "24 Dec, 2023"}
                title={article.title || "Discover a treasure trove of practical tips for enhancing"} 
                description={article.description || "From nutrition advice to exercise routines, we're here to support your journey toward a healthier"} 
                detailsLink={article.detailsLink}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </>
)
}

export default HomePage;

